import api, {
  replaceEmptyArraysWithNulls,
  transformCursorResponse,
  transformRequest,
  transformResponse,
} from "services/api";

export const disputesAPI = api
  .enhanceEndpoints({
    addTagTypes: ["Disputes"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchDisputes: build.query({
        query: (payload) => ({
          url: `/api/v1/core/disputes/`,
          method: "POST",
          body: replaceEmptyArraysWithNulls(transformRequest(payload)),
        }),
        transformResponse: (response) => transformCursorResponse(response),
        providesTags: (response) =>
          response?.results
            ? // successful query
              [
                ...response.results.map(({ id }) => ({ type: "Disputes", id })),
                { type: "Disputes", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'Accounts', id: 'LIST' }` is invalidated
              [{ type: "Disputes", id: "LIST" }],
      }),
      fetchDisputePreview: build.query({
        query: (payload) => ({
          url: `/api/v1/core/disputes/${payload.id}/preview/`,
          method: "GET",
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: (response) =>
          response?.results
            ? // successful query
              [
                ...response.results.map(({ id }) => ({ type: "DisputePreviews", id })),
                { type: "DisputePreview", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'DisputePreviews', id: 'LIST' }` is invalidated
              [{ type: "DisputePreview", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const { useFetchDisputesQuery, useLazyFetchDisputePreviewQuery } = disputesAPI;
